"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Hero() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".sec-headline", {
        filter: "blur(8px)",
        y: 12
      });
      gsap.to(".sec-headline", {
        opacity: 1,
        filter: "blur(0px)",
        y: 0,
        duration: 0.8,
        ease: "power3.out"
      });
      gsap.set(".sec-eyebrow", {
        y: -8
      });
      gsap.to(".sec-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power2.out"
      });
      gsap.set(".sec-body", {
        y: 16
      });
      gsap.to(".sec-body", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        delay: 0.2
      });
      gsap.set(".sec-cta", {
        y: 16
      });
      gsap.to(".sec-cta", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        delay: 0.3
      });
      gsap.to(".sec-halo", {
        opacity: 0.55,
        scale: 1.08,
        duration: 6,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".sec-eyebrow", ".sec-headline", ".sec-body", ".sec-cta"], {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
    });
  }, {
    scope: container
  });
  return;
}